module.exports = __webpack_public_path__ + "static/media/o-pdv-restaurante.bc7a362f.png";